import styled, { css } from 'styled-components';
import themeGet from '@styled-system/theme-get';

import Container from '../../../Core/Container';
import Image from '../../../Core/Image';
import Ctas from '../../../Core/Ctas';

export const StyledSection = styled.section`
  background-color: ${({ $backgroundColor }) =>
    $backgroundColor ? themeGet(`colors.${$backgroundColor}`) : 'transparent'};

  ${({ $backgroundColor }) =>
    $backgroundColor &&
    css`
      padding: 0.1px 0;
    `}
`;

export const Grid = styled(Container)`
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  justify-content: center;
  &.image-bottom-aligned,
  &.image-left-bottom-aligned {
    margin-bottom: 0;
    flex-direction: column;
  }
  max-width: 450px;
  gap: 1rem;

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    max-width: 1024px;
    gap: 2rem;
    flex-direction: row;
    &.image-bottom-aligned,
    &.image-left-bottom-aligned {
      max-width: 1200px;
      margin-top: 60px;
      flex-direction: row;
      justify-content: end;
    }
  }

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    gap: 2.5rem;
  }
`;

export const Content = styled.div`
  ${Grid}.velvet & {
    h2,
    p {
      color: ${({ theme }) => theme.colors.white};
    }
  }
  text-align: center;

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 50%;
    text-align: left;
    ${Grid}.image-left-bottom-aligned &,
    ${Grid}.image-left & {
      order: 2;
    }
  }
`;

export const Header = styled.div`
  margin: 1.5rem auto;
`;

export const CtasWrapper = styled.div`
  ${Grid}.image-left-bottom-aligned &,
  ${Grid}.image-bottom-aligned & {
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
    align-items: center;
  }

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    ${Grid}.image-left-bottom-aligned &,
    ${Grid}.image-bottom-aligned & {
      margin-bottom: 3rem;
      align-items: start;
    }
  }
`;

export const Img = styled(Image)`
  width: 100%;
  justify-self: flex-end;

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: block;
    width: 50%;
    ${Grid}.image-left-bottom-aligned & {
      width: 360px;
      margin: 0 20px 0 10px;
    }
    ${Grid}.image-left & {
      order: 1;
    }
    ${Grid}.image-left-bottom-aligned &,
    ${Grid}.image-bottom-aligned & {
      position: absolute !important;
      left: calc(0% - 3.5rem);
      bottom: 0;
    }
  }

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    width: 45%;
    ${Grid}.image-left-bottom-aligned & {
      width: 400px;
      margin: 0 100px 0 40px;
    }
  }
`;

export const StyledCtas = styled(Ctas)`
  margin: 0;

  a {
    margin: 0;
  }

  ${Grid}.velvet & {
    a {
      color: ${({ theme }) => theme.colors.white};
      &:hover,
      &:focus {
        color: ${({ theme }) => theme.colors['pc-red']};
      }
    }
  }
`;
